import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import '@hotmart-org-ca/cosmos/dist/form/form.css';
import '@hotmart-org-ca/cosmos/dist/form/input-custom.css';
import '@hotmart-org-ca/cosmos/dist/form/input-switch.css';
import clsx from 'clsx';
export const Switch = forwardRef(function Switch({ className, label = '', ...props }, ref) {
    return (_jsxs("div", { className: clsx(className, 'hot-form hot-form--custom hot-form--switch'), children: [_jsx("input", { ...props, type: "checkbox", className: "hot-form__input", ref: ref }), _jsx("label", { className: "hot-form__label", htmlFor: props.id, children: label })] }));
});
